module.exports = __webpack_public_path__ + "components/guide-page/static/icon-wetsuit--rashvest-11663b7b360c8738b7107e8f7e718f13.svg";